<template>
  <div class="new-module-content-bg-grey page-box">
    <div class="main-content">
      <div class="page-title">
        <p class="title-text">获奖作品展示</p>
        <span class="text-en">WORKS SHOW</span>
      </div>
      <div class="select-box">
        <p class="select-item">
          <span>年份 </span>
          <select :value="year" @change="selectFn($event,'year')">
            <option value ="">全部</option>
            <option value ="2017">2017</option>
            <option value ="2018">2018</option>
            <option value ="2019">2019</option>
            <option value ="2020">2020</option>
            <option value ="2021">2021</option>
            <option value ="2022">2022</option>
            <option value ="2023">2023</option>
          </select>
        </p>
        <p class="select-item">
          <select :value="fileType" @change="selectFn($event,'fileType')">
            <option value ="">全部类别</option>
            <option value ="1">图片</option>
            <option value ="2">视频</option>
            <option value ="3">文案</option>
            <option value ="4">音频</option>
          </select>
        </p>
        <p class="select-item">
          <select :value="winType" @change="selectFn($event,'winType')">
            <option value ="">全部奖项</option>
            <option value ="1">一等奖</option>
            <option value ="2">二等奖</option>
            <option value ="3">三等奖</option>
            <option value ="4">精彩卓越奖</option>
            <option value ="5">十佳机构奖</option>
            <option value ="6">十佳艺术指导奖</option>
            <option value ="7">十大明日设计师奖</option>
            <option value ="8">十大优秀导师</option>
            <option value ="9">入围奖</option>
          </select>
        </p>
      </div>
      <template v-if="total > 0">
        <div class="new-module">
          <div class="new-list">
            <template v-for="(item) in worksList">
              <workItem :canToDetail="true" :key="item.id" :workInfo="item"/>
            </template>
          </div>
          <div class="paging-box">
            <pagingEl :current-page="page" :total="total" :page-size="size" @currentChange="getWinWorks"/>
          </div>
        </div>
      </template>
      <template v-if="total <= 0">
        <div class="empty-box">
          <el-empty description="获奖作品列表为空"></el-empty>
        </div>
      </template>
    </div>

  </div>
</template>

<script>
import workItem from "@/components/workItem";
import pagingEl from "@/components/pagingEl";
import {winWorks} from "@/request/api";
export default {
  name: "list",
  components:{
    workItem,
    pagingEl
  },
  data() {
    return {
      year: '',
      fileType: '',
      winType: '',
      worksList:[],
      page: 0,
      total: 0,
      size: 9,
      totalPage: 0,
      prizeObj:{
        1:{
          'yi':1
        },
        2:{
        'er':1, // 二等奖
        },
        3:{
          'san':1, // 三等奖
        },
        4:{
          'zhuoyue':1, // 三等奖
        },
        5:{
          'jigou':1, // 三等奖
        },
        6:{
          'yishu':1, // 三等奖
        },
        7:{
          'sheji':1, // 三等奖
        },
        8:{
          'daoshi':1, // 三等奖
        },
      }
    }
  },
  computed: {},
  created() {
    this.getWinWorks()
  },
  mounted() {
  },
  methods: {
    selectFn(e,typeStr){
      this[typeStr] = e.target.value;
      this.page = 1
      this.getWinWorks()
    },
    //获取获奖作品列表
    getWinWorks(e){
      const {page,size,year,fileType,winType,prizeObj} = this;
      const curPage = e || page
      const keywordsS = {
        year,
        cate:fileType,
        prize:winType ? prizeObj[winType] : {}
      }
      const requestData = {
        page:curPage,
        size,
        type:'won',
        keywords:JSON.stringify(keywordsS)
      };
      console.log(requestData)
      winWorks(requestData).then(res=>{
        let resData = res.data;
        this.worksList = resData.award
        this.total = resData.paging.recordCount
        this.page = curPage
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/css/_var.scss";
.page-box {
  padding-bottom: 130px;
  background-color: #fff;
}
.new-module {
  text-align: center;
  .new-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding-top: 50px;
  }
}
.news-list {
  height: 1000px;
}
.paging-box {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 120px;
  //padding: 0 130px;
}
.select-box {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  .select-item {
    margin-right: 78px;
  }
  select {
    background-color: rgba(0,0,0,0);
  }
}
.empty-box {
  padding-top: 130px;
}
</style>
